import router from "@/router";
import { ElMessage } from "element-plus";

export const isMobie = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};

export const filterFieldByMobie = (field, fieldFilter = false) => {
  return isMobie() ? fieldFilter : field;
};

export const gotoPage = (options = {}) => {
  router.push(options);
};

export const gotoPageByName = (name = "", query = {}) => {
  if (!name) {
    return;
  }

  try {
    gotoPage({
      name,
      query,
    });
  } catch (e) {
    ElMessage.error(String(e));
  }
};
